import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { format } from "date-fns";
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
  Label,
  Input,
  Button,
  Form,
} from "reactstrap";

import viewIcon from "../../assets/images/view_icon.png"; // Replace with your actual icon
import downloadIcon from "../../assets/images/download_icon.png";

const token = sessionStorage.getItem("authToken");

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return isNaN(date) ? dateString : format(date, "PPP"); // Example: "Mar 5, 2025"
};

const isDateField = (key) =>
  ["created_at", "effective_from", "expiry_date"].includes(key.toLowerCase());

const ViewAddendumPage = () => {
  const documentId = useParams();
  const [documentData, setDocumentData] = useState(null);
  const [userName, setUserName] = useState("");
  const [formData, setFormData] = useState({
    title: "",
    reference: "",
    created_by: "",
    // contract_document: ""
  });
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const fetchDocumentData = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_BASE_URL || "";
        if (!apiUrl) {
          console.error("API base URL is not configured.");
          return;
        }

        const response = await fetch(`${apiUrl}/api/addendum/${documentId.id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${sessionStorage.getItem("authToken")}`,
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        
        // const contract_document = new URL(data.contract_document[0]);
        setDocumentData(data.contract_document[0]);
        setFormData({
          title: data.title || "",
          reference: data.reference || "",
          created_by: data.created_by || "",
          // contract_document: data.contract_document || "",
        });

        
      } catch (error) {
        console.error("Error fetching document data:", error);
      }
    };
    
    if (documentId) {
      fetchDocumentData()
    }
  }, [documentId]);
  // console.log({formData})

    // Every time the created_by field changes, get the username from the database using the useEffect hook
    useEffect(()=>{
        const fetchUserName = async ()=>{
            if(formData.created_by){
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/user/${formData.created_by}`, {
                    method: 'GET',
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                });

                if(response.ok){
                    const contUser = await response.json()
                    setUserName(contUser.username)
                } 
                // else {
                //     setUserName(formData.created_by)
                // }
            }
        }
        fetchUserName()
    }, [formData.created_by])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here (e.g., send data to the server)
    console.log("Form submitted with data:", formData);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col md={6}>
              <Card>
                <CardBody>
                  <Form onSubmit={handleSubmit}>
                    {Object.keys(formData).map((key) => (
                      <Row className="mb-3 align-items-center" key={key}>
                        <Label htmlFor={key} className="col-md-4 col-form-label text-md-right p-0 m-0">
                          {key
                            .trim()
                            .replace("_", " ")
                            .split(" ")
                            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                            .join(" ")}
                        </Label>
                        <div className="col-md-8">
                          <Input
                            type="text"
                            name={key}
                            id={key}
                            className="form-control w-100"
                            value={isDateField(key) ? formatDate(formData[key]) : key === "created_by" ? userName || "Loading..." : formData[key]}
                            onChange={handleChange}
                            readOnly
                          />
                        </div>
                      </Row>
                    ))}

                  </Form>
                </CardBody>
              </Card>
            </Col>
            <Col md={6}>
              <Card>
                {                  
                <CardBody>
                  {/* <Row> 
                    <Col md={6}> */}
                      {documentData ? (
                        documentData.type === "image" ? (
                          <div
                            className={`image-container ${isHovered ? "hovered" : ""}`}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                          >
                            {/* Image */}
                            <img
                              src={`${process.env.REACT_APP_API_BASE_URL}/uploads/${documentData.location}`}
                              alt="Document Viewer"
                              className="image"
                            />

                            {/* Icons (Show on Hover) */}
                            {isHovered && (
                              <div className="icon-overlay">
                                <a
                                  href={`${process.env.REACT_APP_API_BASE_URL}/uploads/${documentData.location}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <img src={viewIcon} alt="View" className="icon fw-bold" width={"10dp"}/>
                                </a>

                                <a
                                  href={`${process.env.REACT_APP_API_BASE_URL}/download/${documentData.location}/${JSON.parse(sessionStorage.getItem("authUser"))._id}`}
                                  download
                                >
                                  <img src={downloadIcon} alt="Download" className="icon" />
                                </a>
                              </div>
                            )}
                          </div>
                        ) : documentData.type === "word" || documentData.type === "pdf" || documentData.type === "word" ? (
                          <>
                            <iframe
                              src={`${process.env.REACT_APP_API_BASE_URL}/uploads/${documentData.location}`}
                              title="Document Viewer"
                              width="100%"
                              height="600px"
                              className="document"
                            ></iframe>
                          </>
                        ) : (
                          <p>Document is of another format</p>
                        )
                      ) : (
                        <p>No Addendum Documents Available...</p>
                      )} 
                    {/* </Col>                     
                    <Col md={6}>
                      <Button color="primary" href="/addendums">
                        Change Image
                      </Button>
                    </Col>
                  </Row> */}
                </CardBody>
              }
              </Card>
              <Row className="mb-6">
                <Col md={8}></Col>
                <Col md={4}>
                  <Button color="primary" href="/addendums">
                    Back to addendum
                  </Button>
                </Col>
              </Row>              
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ViewAddendumPage;